import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonRow, IonTitle, IonToast } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack, checkmarkOutline, clipboardOutline, timeOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { cadastraEquipe, listaEquipePorPerfil, requestService, transferirMesa, urlBasePedidos } from '../../../../../Utils/Services';
import "./Transferir.css";


type Props = {
  projetoid: string;
  closeAction: Function;
  closeActionSimple: Function;
};

const Transferir: React.FC<Props> = (props: Props) => {

  // Navigation
  const history = useHistory();

  // Alert and Toast
  const [mostartAlerta] = useIonAlert();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  // Loading State
  const [showLoading, setShowLoading] = useState(false);

  // Contexts
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { loja, setLoja } = useContext(MessageContext);

  // State: Loja
  const [lojas, setLojas] = useState<string>(loja);

  const [textoFiltro, setTextoFiltro] = useState<any>();

  const [pkCliente, setPkCliente] = useState<any>();

  const [listaClienteComanda, setListaClienteComanda] = useState<any>([]);

  const [filter, setFilter] = useState<"todas" | "livres" | "ocupadas">("todas");


  useEffect(() => {
    console.log("props.projetoid", props.projetoid);
    if (props.projetoid != "") {
      console.log("entrou no useEffect");

      buscarComandas("comanda");

    }
  }, []);

  async function unirListas(perfil: any) {
    let listaComandas = await buscarComandasDynamoDb(perfil);
    let listaComandasAbertas = await buscarComandasAbertasDynamoDb();

    // Se qualquer uma das listas for undefined, inicialize-a como uma lista vazia
    listaComandas = listaComandas || [];
    listaComandasAbertas = listaComandasAbertas || [];

    // Criando um mapa para listaComandasAbertas usando clienteid como chave
    let mapaComandasAbertas = new Map(listaComandasAbertas.map((item: any) => [item.clienteid, item]));

    // Unindo as listas
    let listaUnida = listaComandas.map((comanda: any) => {
      let comandaAberta: any = mapaComandasAbertas.get(comanda.pk);

      return {
        ...comanda, // Mapeia as propriedades de comanda
        ...comandaAberta // Mapeia as propriedades de comandaAberta se houver correspondência
      };
    });

    // console.log(listaUnida);

    return listaUnida;
  }

  const buscarComandas = async (perfil: any) => {
    try {
      setShowLoading(true);
      let listaComandas = await unirListas(perfil);

      setListaClienteComanda([]);
      if (Array.isArray(listaComandas) && listaComandas.length > 0) {
        let lista = (listaComandas.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))

        // console.log("lista", lista);
        setListaClienteComanda(lista);

      }
    } catch (error: any) {
      console.error("Ocorreu um problema inesperado. Por favor, tente novamente mais tarde. Detalhes do erro: ", error);
      setTextToast(error);
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }

  }

  const buscarComandasDynamoDb = async (perfil: any) => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23")).concat("?status=ativo&lojas=" + Buffer.from(loja).toString('base64'));


    const resp = await fetch(montarUrl.replace("{perfil}", perfil),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let comandas = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (comandas.Items) {
        if (comandas.Items) {
          if (comandas.Items.length > 0) {
            return comandas.Items;
          }
          else {





            const promises = [];

            for (let i = 1; i <= 10; i++) {
              const numeroMesa = i.toString().padStart(2, '0');
              const objectRequest = {
                cpf: "",
                dataAniversario: "",
                email: "",
                empresaMarca: "",
                endereco: "",
                interno: true,
                lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
                  return lojas.includes(value.empresaLojaId);
                }),
                nome: `Mesa ${numeroMesa}`,
                perfil: "comanda",
                pk: "",
                statusUsuario: "ativo",
                telefone: "55"
              };

              const promise = new Promise((resolve, reject) => {
                requestService(
                  cadastraEquipe.url,
                  {
                    method: cadastraEquipe.method,
                    headers: [["token", localStorage.getItem("token") || ""]],
                    credentials: 'include',
                    body: JSON.stringify(objectRequest)
                  },
                  history,
                  (response: any) => {
                    if (response && response.usuario) {
                      resolve(true);
                    } else {
                      resolve(false);
                    }
                  },
                  (error: any) => {
                    console.log("error", error);
                    reject(error);
                  }
                );
              });

              promises.push(promise);
            }

            Promise.all(promises)
              .then(results => {
                const algumaMesaCriada = results.some((result) => result === true);
                if (algumaMesaCriada) {
                  buscarComandas("comanda");
                }
              })
              .catch(error => {
                console.error("Erro ao cadastrar mesas:", error);
              });






          }
        }
      }
    }
  }

  const buscarComandasAbertasDynamoDb = async () => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let urlFinal = urlBasePedidos.url + "/v2/mesas/listaabertas?filtro=comandas".concat("&lojas=" + Buffer.from(loja).toString('base64'));

    const resp: Response = await fetch(urlFinal,
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let comandas = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (comandas) {
        return comandas;
      }
    }
  }

  function transferir(cliente: any, novoNome: any) {

    setShowLoading(true);

    console.log("props.projetoid", props.projetoid);

    let objRequest = {
      tipo: "comandas",
      id: props.projetoid,
      novoNome: novoNome,
      clienteid: cliente.replaceAll(/#/g, '%23'),
    };

    return requestService(transferirMesa.url.replaceAll("{id}", cliente.replaceAll(/#/g, '%23')).concat("?lojas=" + Buffer.from(loja).toString('base64')), {
      method: transferirMesa.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response && response.message) {
          console.log("response", response);
          props.closeAction(response.message.pk.replaceAll(/#/g, '%23'));
        }

      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message);
        setShowToast(true);
      }).finally(() => {
        setShowLoading(false);
      })


  }


  function tempoAndamento(dataCadastro: any) {
    if (!dataCadastro) {
      // Se não houver dataCadastro, retorna vazio
      return "";
    }

    // Convertendo a dataCadastro para um objeto de data
    const dataCadastrada = new Date(dataCadastro);
    const agora = new Date();

    // Calcula a diferença em milissegundos
    const diferencaMs = agora.getTime() - dataCadastrada.getTime();

    // Converte para unidades de tempo
    const minutos = Math.floor(diferencaMs / 1000 / 60) % 60; // Restante dos minutos
    const horas = Math.floor(diferencaMs / 1000 / 60 / 60) % 24; // Restante das horas
    const dias = Math.floor(diferencaMs / 1000 / 60 / 60 / 24); // Total de dias

    // Formatação da saída
    let resultado = "";

    if (dias > 0) {
      resultado += `${dias} ${dias === 1 ? "dia" : "dias"}`;
      return resultado;
    }
    if (horas > 0) {
      resultado += `${dias > 0 ? ", " : ""}${horas} ${horas === 1 ? "hora" : "horas"}`;
    }
    if (minutos > 0) {
      resultado += `${dias > 0 || horas > 0 ? " e " : ""}${minutos} ${minutos === 1 ? "minuto" : "minutos"}`;
    }

    return resultado || "Agora mesmo";
  }

  function readListaComandas() {

    let listaFiltrada = textoFiltro
      ? listaClienteComanda.filter((value: any) =>
        value.nome.toLowerCase().includes(textoFiltro?.toLowerCase())
      )
      : listaClienteComanda;

    if (filter == "ocupadas") {
      listaFiltrada = listaFiltrada.filter((value: any) =>
        value.sk != ""
      )
    }

    return listaFiltrada.map((value: any, index: any) => (
      <>
        {((filter == "todas" || (value.sk && filter == "ocupadas") || (!value.sk && filter == "livres")) &&
          <IonCol sizeMd="3" size="6" key={value.id}>
            <IonCard style={{ margin: "2px", minHeight: "130px" }}
              // color={(value.clienteid ?? value.pk) == pkCliente ? "danger" : 'light'}
              button
              onClick={() => {

                console.log("value.clienteid", value.clienteid);
                console.log("value.pk", value.pk);
                setPkCliente(value.clienteid || value.pk);

                if (value.clienteid) {
                  setTextToast("Você não pode transferir para uma mesa aberta.");
                  setShowToast(true);
                }
                else {
                  if (acessos?.comandas == 'edicao') {
                    mostartAlerta({
                      backdropDismiss: false,
                      header: 'Transferir ' + (window.localStorage.getItem("nomeInternoMesaOuComanda") || "Mesa"),
                      message: `
                        <div>
                          <ion-item lines="none">
                            <ion-input id="editableTitle"></ion-input>
                          </ion-item>
                        </div>
                      `,
                      buttons: [
                        {
                          text: 'Cancelar',
                          role: 'cancel',
                          handler: () => {
                            setPkCliente("");
                          },
                        },
                        {
                          text: 'Abrir',
                          handler: async () => {
                            const inputElement: any = document.querySelector('#editableTitle');
                            const editedTitle = inputElement?.value || value.nome;
                            console.log('Título editado:', editedTitle);
                            transferir(value.pk, editedTitle);
                          },
                        },
                      ],
                      onDidPresent: () => {
                        // Define o valor no input após o alerta aparecer
                        const inputElement: any = document.querySelector('#editableTitle');
                        if (inputElement) {
                          inputElement.value = value.nome;
                        }
                      },
                      onDidDismiss: () => {
                        console.log('did dismiss');
                      },
                    });
                  }
                  else {
                    setTextToast("Você não tem permissão para acessar esta funcionalidade.");
                    setShowToast(true);
                  }
                }
              }}
            >

              <IonCardContent>
                {value.sk ? (
                  <IonChip color={'danger'}>
                    <IonIcon icon={clipboardOutline} />
                    <IonLabel>Aberta</IonLabel>
                  </IonChip>
                ) : (
                  <IonChip color={'success'}>
                    <IonIcon icon={checkmarkOutline} />
                    <IonLabel>Livre</IonLabel>
                  </IonChip>
                )}
                <div>
                  <IonLabel className="ion-text-wrap">
                    <b>{value.clienteNome || value.nome}</b>
                  </IonLabel>
                </div>

                <IonLabel>
                  <p>{value.valorTotal ? `R$ ${value.valorTotal}` : 'R$ 0,00'}</p>
                </IonLabel>

                {value.dataCadastro && (
                  <div style={{ textAlign: "right", fontSize: "12px" }}>
                    <IonIcon icon={timeOutline} /> {tempoAndamento(value.dataCadastro)}
                  </div>
                )}
              </IonCardContent>
            </IonCard>
          </IonCol >
        )
        }
      </>

    ));
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">

          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              props.closeActionSimple();
            }} />
          </IonButtons>
          <IonTitle>Transferir</IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false}>


        <IonGrid>
          <IonRow>
            {readListaComandas()}
          </IonRow>
        </IonGrid>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>

    </>


  );
};

export default ({ projetoid, closeAction, closeActionSimple }: { projetoid: any, closeAction: Function, closeActionSimple: Function }) => (
  <Transferir projetoid={projetoid} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </Transferir>
)
